import React, { useState, useContext, useEffect } from "react";
import {
	ToggleButton,
	CircularProgress,
	Tooltip,
	Box,
	alpha,
} from "@mui/material";
import {
	Bookmark as BookmarkIcon,
	BookmarkBorder as BookmarkBorderIcon,
} from "@mui/icons-material";

import { SiteContext, SingleContext, saveBookmark } from "gatsby-frontend";

export default function BookmarkToggle({ color }) {
	const { dispatch, isAuthenticated, userData, setUserData } =
		useContext(SiteContext);

	const { id, type } = useContext(SingleContext);

	const [submitting, setSubmitting] = useState(false);
	const [bookmarked, setBookmarked] = useState(false);

	useEffect(() => {
		if (userData && isPageBookmarked()) {
			setBookmarked(true);
		} else {
			setBookmarked(false);
		}
	}, [userData]);

	const bookmarkPage = async () => {
		try {
			setSubmitting(true);

			let _dispatch = isAuthenticated ? dispatch : null;
			let response = await saveBookmark(
				_dispatch,
				userData,
				id,
				type,
				bookmarked
			);
			if (response !== false) {
				setUserData(response.data);
			}

			setSubmitting(false);
		} catch (e) {
			setSubmitting(false);
		}
	};

	const isPageBookmarked = () => {
		let found = userData.relationships.field_bookmarks.data.find(
			(item) => item.id === id
		);
		return found != undefined ? true : false;
	};

  color = color || "rgba(0, 0, 0, 0.87)";

	return (
		<Box
			sx={(theme) => ({
				position: "relative",
				display: "inline-block",
				marginLeft: theme.spacing(2),
				"& svg": {
					color: color,
				},
			})}
		>
			<Tooltip title={!bookmarked ? "Bookmark page" : "Remove Bookmark"}>
				<ToggleButton
					value="check"
					selected={bookmarked}
					onChange={() => {
						bookmarkPage();
					}}
					sx={{ borderColor: alpha(color, 0.25), borderRadius: "50%" }}
				>
					{submitting ? (
						<CircularProgress size={24} />
					) : bookmarked ? (
						<BookmarkIcon />
					) : (
						<BookmarkBorderIcon />
					)}
				</ToggleButton>
			</Tooltip>
		</Box>
	);
}
